import { Link, useNavigate } from "react-router-dom";
import { mdiAndroid, mdiApple } from "@mdi/js";
import Icon from "@mdi/react";
import clsx from "clsx";

import Button from "components/Button";
import { routes } from "constants/routes";
import useDeviceType from "hooks/useDeviceType";
import styles from "./style.module.scss";
import { useSelector } from "react-redux";
import { selectOnboardingInformation } from "store/user/selector";

export default function InvitedCarrierComplete() {
  const navigate = useNavigate();
  const { isDesktop } = useDeviceType();
  const onboardingInformation = useSelector(selectOnboardingInformation);

  function goToHome() {
    navigate(routes.SIGNIN);
  }

  return (
    <div className={styles.completeContainer}>
      {onboardingInformation.show_rmis_link_onboarding && (
        <div className={styles.agreement}>
          <span className="text-sm font-thin">
            Please click below to finish the broker’s enrolment process if you haven’t already.
          </span>

          <Link to={onboardingInformation.rmis_url} target={"_blank"}>
            BROKER AGREEMENT VIA RMIS
          </Link>
        </div>
      )}

      <div className={clsx(styles.goBackHomeButton, !isDesktop && "!border-none")}>
        <Button type="button" rounded className="!h-12 !w-3/4 mx-auto" onClick={goToHome}>
          Go Back Home
        </Button>
      </div>

      {onboardingInformation.show_onboarding_haulpay_app && (
        <div className={styles.footer}>
          <span>
            You can also use the optional HaulPay mobile app to track and manage your payments.
          </span>

          <div className={styles.buttons}>
            <Button rounded className={clsx(styles.downloadButton, "!h-12 !w-3/4")}>
              <Icon path={mdiAndroid} />
              <span>Download For Android</span>
            </Button>
            <Button rounded className={clsx(styles.downloadButton, "!h-12 !w-3/4")}>
              <Icon path={mdiApple} />
              <span>Download For iPhone</span>
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}
